import { createAsyncThunk } from "@reduxjs/toolkit"
import Api from "../api/api"
import type { RootState } from "./store"

// GET /me/library — lives in its own leaf module so licensesSlice can
// hydrate license entities from the library payload without importing
// librarySlice (which imports the other slices' thunks for invalidation).
export const libraryThunk = createAsyncThunk(
    'library/fetch',
    async ({ accessToken }: { accessToken: string }, { getState, requestId }) => {
        const state = getState() as RootState
        const { currentRequestId } = state.library.library
        if (currentRequestId !== requestId)
            throw new Error("Request outdated")
        return await Api.getLibrary({ accessToken })
    }
)

// POST /me/entitlements/{id}/transfers — here for the same reason: both
// librarySlice (invalidate) and licensesSlice (evict the moved rows) react
// to it.
export const transferEntitlementThunk = createAsyncThunk(
    'library/transferEntitlement',
    async ({ entitlementId, toUserId, accessToken }: { entitlementId: string, toUserId: string, accessToken: string }) => {
        return await Api.transferEntitlement({ entitlementId, toUserId, accessToken })
    }
)
